// admin-user-api.js

import axios from 'axios'
import { API_URL } from '@/config/api.config'


const adminUserAPI = {
    /**
     * 后台账号登录
     */
    login: async (username, password) => {
        try {
            const response = await axios.post(`${API_URL}/admin/login`, { username, password });
            return response.data;
        } catch (error) {
            console.error('登录失败:', error);
            throw error;
        }
    },
    /**
     * 获取当前用户信息
     */
    getCurrentUser: async () => {
        try {
            const response = await axios.get(`${API_URL}/admin/current-user`);
            return response.data;
        } catch (error) {
            console.error('获取用户信息失败:', error);
            throw error;
        }
    },

    /**
     * 退出登录
     */
    logout: async () => {
        try {
            const response = await axios.post(`${API_URL}/admin/logout`);
            return response.data;
        } catch (error) {
            console.error('退出登录失败:', error);
            throw error;
        }
    }
};

export default adminUserAPI;